import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Keys } from "app/models/core/keys";
import { IDemographics } from "app/models/core/lab/demographics";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";
import { Subscription } from "rxjs";


@Component({
  selector: 'app-demographics',
  templateUrl: './demographics.component.html',
  styleUrls: ['./demographics.component.scss'],})

export class DemographicsComponent implements OnInit {
  @Input() stateNumber: string = '';

  demog: IDemographics;
  getDemog: Subscription;

  isDirty = false;
  editMode = false;
  createdBy = '';
  createDate = '';
  updatedBy = '';
  updateDate = '';
  mapLink = '';
  type = '';

  certList = Keys.certType2;
  accList = Keys.accreditationCode;
  complexList = Keys.complexityType;
  labTypeList = Keys.labType;
  hoursList = Keys.officeHours;
  ownershipList = Keys.ownershipTypes;
  countyList = Keys.countyCode;

  labFormGroup = new UntypedFormGroup({
    LabId: new UntypedFormControl(''),
    LabName: new UntypedFormControl('', [Validators.required, Validators.maxLength(66)]),
    StateNumber: new UntypedFormControl('', [Validators.required, Validators.pattern(/[0-9]/), Validators.maxLength(10)]),
    CliaNumber: new UntypedFormControl('', [Validators.maxLength(11)]),
    LabType: new UntypedFormControl('', [Validators.maxLength(2)]),
    LabTypeDescription: new UntypedFormControl('',),
    LabDirector: new UntypedFormControl('', [Validators.maxLength(100)]),
    Npi: new UntypedFormControl('', [Validators.maxLength(10)]),
    Shared: new UntypedFormControl(Boolean, [Validators.maxLength(10)]),
    OwnerType: new UntypedFormControl('', [Validators.maxLength(2)]),
    TaxId: new UntypedFormControl('', [Validators.maxLength(10)]),
    MailAddress: new UntypedFormControl('', [Validators.maxLength(100)]),
    MailCity: new UntypedFormControl('', [Validators.maxLength(200)]),
    MailState: new UntypedFormControl('', [Validators.maxLength(2)]),
    MailZip: new UntypedFormControl('', [Validators.maxLength(10), Validators.pattern(/^\d{5}(-\d{4})?$/)]),
    SiteAddress: new UntypedFormControl('', [Validators.maxLength(100)]),
    SiteCity: new UntypedFormControl('', [Validators.maxLength(200)]),
    SiteState: new UntypedFormControl('', [Validators.maxLength(2)]),
    SiteZip: new UntypedFormControl('', [Validators.maxLength(10), Validators.pattern(/^\d{5}(-\d{4})?$/)]),
    PhoneNumber: new UntypedFormControl('', [Validators.pattern(/^\(?([0-9]{3})\)?[ ]?[-]?([0-9]{3})[-]?([0-9]{4}?(x\d{4})?).*$/)]),
    FaxNumber: new UntypedFormControl('', [Validators.pattern(/^\(?([0-9]{3})\)?[ ]?[-]?([0-9]{3})[-]?([0-9]{4}).*$/)]),
    DirectorEmail: new UntypedFormControl('', [Validators.maxLength(100)]),
    Director: new UntypedFormControl('', [Validators.maxLength(100)]),
    Manager: new UntypedFormControl('', [Validators.maxLength(100)]),
    CountyCode: new UntypedFormControl('', [Validators.maxLength(3)]),
    CountyCodeName: new UntypedFormControl('',),
    CliaSchedule: new UntypedFormControl('', [Validators.maxLength(1)]),
    CloseDate: new UntypedFormControl('',),
    AcCredit: new UntypedFormControl('', [Validators.maxLength(10)]),
    LabFee: new UntypedFormControl('',),
    TotalVolume: new UntypedFormControl('',),
    Complexity: new UntypedFormControl('', [Validators.maxLength(1)]),
    Recognized: new UntypedFormControl('', [Validators.maxLength(1)]),
    UpdatedBy: new UntypedFormControl('',),
    LastUpdated: new UntypedFormControl('',),
    FirstEnt: new UntypedFormControl('',),
    FirstLic: new UntypedFormControl('',),
    Comments: new UntypedFormControl('', [Validators.maxLength(4000)]),
    Closed: new UntypedFormControl('', [Validators.maxLength(1)]),
    Upn: new UntypedFormControl('', [Validators.maxLength(10)]),
    CliaCertificateExpiration: new UntypedFormControl('',),
    DirectorPhone: new UntypedFormControl('', [Validators.pattern(/^\(?([0-9]{3})\)?[ ]?[-]?([0-9]{3})[-]?([0-9]{4}).*$/), Validators.maxLength(100)]),
    ManagerPhone: new UntypedFormControl('', [Validators.pattern(/^\(?([0-9]{3})\)?[ ]?[-]?([0-9]{3})[-]?([0-9]{4}).*$/), Validators.maxLength(100)]),
    ManagerEmail: new UntypedFormControl('', [Validators.maxLength(100)]),
    Hst: new UntypedFormControl(Boolean, [Validators.maxLength(1)]),
    Soa: new UntypedFormControl(Boolean, [Validators.maxLength(1)]),
    SoaKit: new UntypedFormControl('',),
    SoaYear: new UntypedFormControl('',),
    Multiple: new UntypedFormControl(Boolean, [Validators.maxLength(1)]),
    Lrn: new UntypedFormControl(Boolean, [Validators.maxLength(1)]),
    LrnId: new UntypedFormControl('',),
    OfficeHours: new UntypedFormControl('', [Validators.maxLength(20)]),
    OfficeComments: new UntypedFormControl('', [Validators.maxLength(4000)]),
    DateCreated: new UntypedFormControl('',),
    CreatedBy: new UntypedFormControl('', [Validators.maxLength(50)]),
    ParentId: new UntypedFormControl('',),
    CertificateType: new UntypedFormControl('', [Validators.maxLength(1)]),
    SharedMulitText: new UntypedFormControl('', [Validators.maxLength(100)]),
    PaidCompliance: new UntypedFormControl('',),
    LastSurveyDate: new UntypedFormControl('',),
    OutOfState: new UntypedFormControl(Boolean, [Validators.maxLength(1)]),
    CovidLab: new UntypedFormControl(Boolean, [Validators.maxLength(1)])
  });

  constructor(public labService: LabService,
    public sharedService: SharedService) { };

  ngOnInit(): void { 
    if (this.labService.lab != null){
      this.demog = this.labService.lab;
      this.type = this.demog.labType;
      this.setForm();
      this.createdBy = this.demog.createdBy;
      this.createDate = this.demog.dateCreated
      this.updatedBy = this.demog.updatedBy;
      this.updateDate = this.demog.lastUpdated;
      this.labFormGroup.disable();
      this.mapLink = 'https://www.google.com/maps/search/?api=1&query=' + 
          this.demog.siteAddress + '+' + this.demog.siteCity + '+' + 
          this.demog.siteState + '+' + this.demog.siteZip;
      this.labService.certType = this.demog.certificateType;
      }
  }

  getDemographics(){
    this.getDemog = this.labService.getLab(this.stateNumber).subscribe(
      res => {
        this.demog = res;
        this.labService.lab = res;
        this.setForm();
        this.type = this.demog.labType;
      },
      error => console.log('error', error),
      () => {
        this.createdBy = this.demog.createdBy;
        this.createDate = this.demog.dateCreated
        this.updatedBy = this.demog.updatedBy;
        this.updateDate = this.demog.lastUpdated;
        this.editMode = false;
        this.labFormGroup.disable();
        this.mapLink = 'https://www.google.com/maps/search/?api=1&query=' + 
            this.demog.siteAddress + '+' + this.demog.siteCity + '+' + 
            this.demog.siteState + '+' + this.demog.siteZip;
        this.labService.certType = this.demog.certificateType;
        }
    );
  }

  setForm(){
    this.labFormGroup.patchValue({
      LabId: this.demog.labId,
      LabName: this.demog.labName,
      StateNumber: this.demog.stateNumber,
      CliaNumber: this.demog.cliaNumber,
      LabType: this.demog.labType,
      LabTypeDescription: this.demog.labTypeDescription,
      LabDirector: this.demog.labDirector,
      Npi: this.demog.npi,
      Shared: this.demog.shared == 'Y'? true : false,
      OwnerType: this.demog.ownerType,
      TaxId: this.demog.taxId,
      MailAddress: this.demog.mailAddress,
      MailCity: this.demog.mailCity,
      MailState: this.demog.mailState,
      MailZip: this.demog.mailZip,
      SiteAddress: this.demog.siteAddress,
      SiteCity: this.demog.siteCity,
      SiteState: this.demog.siteState,
      SiteZip: this.demog.siteZip,
      PhoneNumber: this.demog.phoneNumber,
      FaxNumber: this.demog.faxNumber,
      DirectorEmail: this.demog.directorEmail,
      Director: this.demog.director,
      Manager: this.demog.manager,
      CountyCode: this.demog.countyCode,
      CountyCodeName: this.demog.countyCodeName,
      CliaSchedule: this.demog.cliaSchedule,
      CloseDate: this.demog.closeDate,
      AcCredit: this.demog.acCredit,
      LabFee: this.demog.labFee,
      TotalVolume: this.demog.totalVolume,
      Complexity: this.demog.complexity,
      Recognized: this.demog.recognized,
      UpdatedBy: this.demog.updatedBy,
      LastUpdated: this.demog.lastUpdated,
      FirstEnt: this.demog.firstEnt,
      FirstLic: this.demog.firstLic,
      Comments: this.demog.comments,
      Closed: this.demog.closed,
      Upn: this.demog.upn,
      CliaCertificateExpiration: this.demog.cliaCertificateExpiration,
      DirectorPhone: this.demog.directorPhone,
      ManagerPhone: this.demog.managerPhone,
      ManagerEmail: this.demog.managerEmail,
      Hst: this.demog.hst == 'Y'? true : false,
      Soa: this.demog.soa == 'Y'? true : false,
      SoaKit: this.demog.soaKit,
      SoaYear: this.demog.soaYear,
      Multiple: this.demog.multiple == 'Y'? true : false,
      Lrn: this.demog.lrn == 'Y'? true : false,
      LrnId: this.demog.lrnId,
      OfficeHours: this.demog.officeHours,
      OfficeComments: this.demog.officeComments,
      DateCreated: this.demog.dateCreated,
      CreatedBy: this.demog.createdBy,
      ParentId: this.demog.parentId,
      CertificateType: this.demog.certificateType,
      SharedMulitText: this.demog.sharedMulitText,
      PaidCompliance: this.demog.paidCompliance,
      LastSurveyDate: this.demog.lastSurveyDate,
      OutOfState: this.demog.outOfState == 'Y'? true : false,
      CovidLab: this.demog.covidLab == 'Y'? true : false
    }
    );
  }

  printLabDemographics() {
    if (this.demog != null) {
      this.labService.printDemog(this.demog.stateNumber).subscribe(
        response => this.downloadFile("Demographics", response),
        error => console.log('error', error)
      );
    }
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }

  editLab() {
    this.editMode = true;
    this.labFormGroup.enable();
    
  }

  saveLabDemographics() {
    if (this.labFormGroup.valid){
      let form = this.labFormGroup.value;
      let laboratory: IDemographics = {
        labId: form.LabId,
        labName: form.LabName,
        stateNumber: form.StateNumber,
        cliaNumber: form.CliaNumber,
        labType: form.LabType,
        labTypeDescription: form.LabTypeDescription,
        labDirector: form.LabDirector,
        npi: form.Npi,
        shared: form.Shared ? 'Y' : 'N',
        ownerType: form.OwnerType,
        taxId: form.TaxId,
        mailAddress: form.MailAddress,
        mailCity: form.MailCity,
        mailState: form.MailState,
        mailZip: form.MailZip,
        siteAddress: form.SiteAddress,
        siteCity: form.SiteCity,
        siteState: form.SiteState,
        siteZip: form.SiteZip,
        phoneNumber: form.PhoneNumber,
        faxNumber: form.FaxNumber,
        directorEmail: form.DirectorEmail,
        director: form.Director,
        manager: form.Manager,
        countyCode: form.CountyCode,
        countyCodeName: form.CountyCodeName,
        cliaSchedule: form.CliaSchedule,
        closeDate: form.CloseDate,
        acCredit: form.AcCredit,
        labFee: form.LabFee,
        totalVolume: form.TotalVolume,
        complexity: form.Complexity,
        recognized: form.Recognized,
        updatedBy: form.UpdatedBy,
        lastUpdated: form.LastUpdated,
        firstEnt: form.FirstEnt,
        firstLic: form.FirstLic,
        comments: form.Comments,
        closed: form.Closed,
        upn: form.Upn,
        cliaCertificateExpiration: form.CliaCertificateExpiration,
        directorPhone: form.DirectorPhone,
        managerPhone: form.ManagerPhone,
        managerEmail: form.ManagerEmail,
        hst: form.Hst ? 'Y' : 'N',
        soa: form.Soa ? 'Y' : 'N',
        soaKit: form.SoaKit,
        soaYear: form.SoaYear,
        multiple: form.Multiple ? 'Y' : 'N',
        lrn: form.Lrn ? 'Y' : 'N',
        lrnId: form.LrnId,
        officeHours: form.OfficeHours,
        officeComments: form.OfficeComments,
        dateCreated: form.DateCreated,
        createdBy: form.CreatedBy,
        parentId: form.ParentId,
        certificateType: form.CertificateType,
        sharedMulitText: form.SharedMulitText,
        paidCompliance: form.PaidCompliance,
        lastSurveyDate: form.LastSurveyDate,
        outOfState: form.OutOfState ? 'Y' : 'N',
        covidLab: form.CovidLab ? 'Y' : 'N'
      }
      this.labService.saveLabDemographics(laboratory).subscribe(
        res => {
          this.demog = res;
          this.getDemographics();
        },
        error => console.log('error', error),
        () => {
        }
      );
  
    }
  }

  cancelLab() {
    if (this.checkDirty()) {
      if (!confirm('Unsaved changes. Continue?')) {
        return;
      }
    }
    this.getDemographics();
  }

  checkDirty(): boolean {
    return this.labFormGroup.dirty;
  }

  copyAddress(): void {
    this.labFormGroup.patchValue({
      SiteAddress: this.labFormGroup.controls['MailAddress'].value,
      SiteCity: this.labFormGroup.controls['MailCity'].value,
      SiteState: this.labFormGroup.controls['MailState'].value,
      SiteZip: this.labFormGroup.controls['MailZip'].value,
    });
  }

  mapAddress(): void {

  }
}
